import React from "react";
import { HeadingLevel } from "../../Heading";
import { incrementHeadingLevel } from "../../../helpers/incrementHeadingLevel";
import ProductFilter from "./ProductFilter";
import { productFilterListStyles as styles } from "../styles";
import { useProductFilters } from "../../../contexts/ProductFilterContext";

interface ProductFilterProps {
  headingLevel: HeadingLevel;
}

const Filters = ({ headingLevel }: ProductFilterProps) => {
  const { availableFilters, filteredProducts, products } = useProductFilters();
  const productCount =
    filteredProducts.length === products.length
      ? `All ${products.length}`
      : filteredProducts.length;
  const title =
    availableFilters.brands.length === 0 ||
    availableFilters.categories.length === 0
      ? `${productCount} Products`
      : undefined;
  return (
    <div css={styles.container}>
      {availableFilters.brands.length > 0 && (
        <ProductFilter
          headingLevel={incrementHeadingLevel(headingLevel, 1)}
          items={availableFilters.brands}
          filterType="brands"
          title={title}
        />
      )}
      {availableFilters.categories.length > 0 && (
        <ProductFilter
          headingLevel={incrementHeadingLevel(headingLevel, 1)}
          items={availableFilters.categories}
          filterType="categories"
          title={title}
        />
      )}
    </div>
  );
};

export default Filters;
